import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "src/app/components/grid/EntityGrid";

const useKeywordsGridColumns = (): Array<SimpleEntityGridColumn> => {
    const { formatMessage } = useIntl();
    return [
        {
            field: "domain",
            headerName: formatMessage({ id: "sites.grid.col.domain" }),
            pinned: "left",
        },
        {
            field: "network",
            headerName: formatMessage({ id: "sites.grid.col.pbn" }),
            maxWidth: 70,
        },
        {
            field: "kw",
            headerName: formatMessage({ id: "sites.grid.col.kw" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            maxWidth: 80,
        },
        {
            field: "traffic",
            headerName: formatMessage({ id: "sites.grid.col.traffic" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            maxWidth: 80,
        },
    ];
};

export default useKeywordsGridColumns;
